"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Client_1 = __importDefault(require("./Client"));
const ApiCompanySettings = {
    getSettings(token) {
        return Client_1.default.httpGet("/companysettings/get", token);
    },
    setSetting(token, setting, value) {
        return Client_1.default.httpPost("/companysettings/set/" + setting, token, value);
    },
    getCodes(token) {
        return Client_1.default.httpGet("/companysettings/codes/get", token);
    },
    setCode(token, type, value) {
        return Client_1.default.httpPost("/companysettings/codes/set/" + type, token, value);
    },
    getPayThreshold(token) {
        return Client_1.default.httpGet("/companysettings/pay/threshold", token);
    },
    setPayThreshold(token, value) {
        return Client_1.default.httpPut("/companysettings/pay/threshold", token, value);
    },
    getBirthdayCard(token) {
        return Client_1.default.httpGet("/companysettings/birthday-card", token);
    },
    setBirthdayCard(token, value) {
        return Client_1.default.httpPost("/companysettings/birthday-card", token, value);
    },
    getBirthdayCardSetting(token) {
        return this.getBirthdayCard(token);
    },
    setBirthdayCardSetting(token, value) {
        return this.setBirthdayCard(token, value);
    },
    getOnboarding(token) {
        return Client_1.default.httpGet("/companysettings/onboarding", token);
    },
};
exports.default = ApiCompanySettings;
